import { render } from "./linkPermission.vue?vue&type=template&id=fe305a66&scoped=true"
import script from "./linkPermission.vue?vue&type=script&lang=js"
export * from "./linkPermission.vue?vue&type=script&lang=js"

import "./linkPermission.vue?vue&type=style&index=0&id=fe305a66&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe305a66"]])

export default __exports__